import {
  SET_LOADING,
  GET_DASHBOARD_DISPUTES,
  GET_DASHBOARD_PAYMENTS,
  GET_DASHBOARD_TOP_STORES,
  GET_DASHBOARD_TOP_PRODUCTS,
  GET_DASHBOARD_TOP_CAMPAIGNS,
  GET_DASHBOARD_SHOPIFY,
  DASHBOARD_ERROR,
} from "../types";

const DashboardReducer = (state, action) => {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        loading: true,
      };

    case GET_DASHBOARD_DISPUTES:
      return {
        ...state,
        disputes: action.payload.disputes,
        loading: false,
      };

    case GET_DASHBOARD_PAYMENTS:
      return {
        ...state,
        payments: action.payload.payments,
        loading: false,
      };

    case GET_DASHBOARD_TOP_STORES:
      return {
        ...state,
        stores: action.payload.stores,
        loading: false,
      };

    case GET_DASHBOARD_TOP_CAMPAIGNS:
      return {
        ...state,
        campaigns: action.payload.campaigns,
        loading: false,
      };

    case GET_DASHBOARD_TOP_PRODUCTS:
      return {
        ...state,
        products: action.payload.products,
        loading: false,
      };

    case GET_DASHBOARD_SHOPIFY:
      return {
        ...state,
        shopify: action.payload.shopify,
        loading: false,
      };

    case DASHBOARD_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default DashboardReducer;